export const REACT_APP_INSTAGRAM_ACCESS_TOKEN = "IGAGXpGgs3s6ZABZAGFLMEdHZAzZAWM0ZARb3U3dnBBQmhPSF9ZAd3d4ZAmZA3XzhHam9vT3BLNlRTMktRMTUyTWphUkljN1BDdnpIMWtEY3k2MDYzbkVHSFhwOS1kTU0zQzd5Tk11cG1TREF5YVprc1I2dkF0OFpYZAVlBekhtb2lYQlBiVQZDZD"

export const REACT_APP_API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

